import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ValidationSummary } from '../../shared/misc-classes';

@Component({
  selector: 'validation-dialog',
  templateUrl: 'validation-dialog.html',
  styleUrls: ['./validation-dialog.css']
  //changeDetection:ChangeDetectionStrategy.OnPush
})
export class ValidationDialog {

  constructor(
    public dialogRef: MatDialogRef<ValidationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ValidationSummary) {
     }

  onNoClick(): void {
    this.dialogRef.close();
  }

}